/* eslint-disable consistent-return */
import React, { useEffect } from 'react';
import '../../stylesheets/app.scss';
import { NavigationBarAndMenu, Footer } from '@library/shared-ui';
import { initZendeskWidget } from './zendesk';
import { getSessionStorage } from '../../utils/sessionManager';
import { ScreenSizeConfigurator } from '../../../../../library/shared-ui/components/ScreenSizeConfigurator';
import { getCookiePreferences } from '../../../../../library/shared-ui/components/CookiePreferenceBanner/utils';
import {
  optFullStory,
  optApollo,
  optVWO,
} from '../../../../../library/shared-ui/components/CookiePreferenceBanner/injections';

const SearchUiSuggestions = React.lazy(() => import('../SearchUiSuggestions'));

const Layout = ({ children, data }) => {
  const showToPercentage = (max) => {
    return Math.floor(Math.random() * Math.floor(max));
  };

  const schema = React.useMemo(
    () =>
      children?.props?.children?.props?.children?.props?.data ||
      children?.props?.data ||
      data,
    [
      children?.props?.children?.props?.children?.props?.data,
      children?.props?.data,
      data,
    ]
  );
  const locales = React.useMemo(
    () =>
      children?.props?.children?.props?.children?.props ||
      children?.props ||
      data,
    [children?.props?.children?.props?.children?.props, children?.props, data]
  );

  const isBuilderPage = !!locales?.pageContext?.isBuilderPage;

  const navbarMenuSection = isBuilderPage
    ? schema?.contentfulNavigationBarAndMenu
    : schema?.contentfulPageTemplate?.navbarMenuSection;

  const footer = isBuilderPage
    ? schema?.contentfulFooter
    : schema?.contentfulPageTemplate?.footerSection;

  useEffect(() => {
    (async () => {
      const fullStory = getSessionStorage('fullStory');
      const { allowedAll } = await getCookiePreferences();
      // verifies we are in prod - random initialization of fullstory if new session
      if (process.env.GATSBY_TARGET_ENV === '1' && fullStory !== 'true') {
        if (showToPercentage(10) === 0) {
          optFullStory(allowedAll);
        }
      }

      initZendeskWidget(process.env.GATSBY_ZENDESK_KEY);
      optApollo(allowedAll);
      optVWO(allowedAll);
    })();
  }, []);

  return (
    <ScreenSizeConfigurator>
      {!!navbarMenuSection && (
        <NavigationBarAndMenu
          {...navbarMenuSection}
          showSearchSuggestions
          searchSuggestions={<SearchUiSuggestions />}
          mobileButton={undefined}
        />
      )}
      <main>{children}</main>
      {!!footer && (
        <Footer
          {...footer}
          pageContext={locales?.pageContext || locales?.allContentfulLocale}
        />
      )}
    </ScreenSizeConfigurator>
  );
};

export default Layout;
